






























import { DxDataGrid, DxColumn, } from 'devextreme-vue/data-grid';
import { Component, Prop, Vue } from "vue-property-decorator";

import { httpService } from "../services/HttpService";

import { eventService } from "../services/EventService";

import CustomStore from "devextreme/data/custom_store";
import moment from "moment";

import ODataService from "../services/ODataService";

@Component({
  components: { 
    DxDataGrid,
    DxColumn 
  }
})
export default class GridOData extends Vue {
  odataService: ODataService = new ODataService();
  @Prop({ type: String, default: "gridOData" })
  idGrid: any | string;
  
  grid: any;

  @Prop({ type: Boolean, default: false })
  searchPanelVisible: any | boolean;

  searchPanel: any = {
    visible: this.searchPanelVisible,
    width: 240,
    placeholder: "Buscar..."
  };

  @Prop({ type: Boolean, default: false })
  headerFilterVisible: any | boolean;
  headerFilter: any = {
    visible: this.headerFilterVisible
  };

  @Prop({ type: Boolean, default: false })
  columnChooserVisible: any | boolean;
  columnChooser: any = {
    enabled: this.columnChooserVisible
  };

  @Prop({ type: Boolean, default: false })
  exportDataVisible: any | boolean;
  exportData: any = {
    enabled: this.exportDataVisible,
    fileName: "Export",
    allowExportSelectedData: true
  };

  @Prop({ type: Boolean, default: false })
  groupPanelVisible: any | boolean;
  groupPanel: any = {
    visible: this.groupPanelVisible
  };

  datasource: any;

  // Función que se encarga de cargar los datos en el datasource
  @Prop([Function])
  loadDataSource: any | Function;

  @Prop([Array])
  columns: any | Array<any>;

  @Prop({ type: String, default: "Id" })
  keyExpr: any | string;

  @Prop({ type: String, default: "100%" })
  width: any | string;

  @Prop({ type: Number, default: 600 })
  height: any | number;

  @Prop({ type: String, default: "single" })
  selectionMode: any | string;
  selection: any = { mode: this.selectionMode };

  @Prop({ type: Boolean, default: true })
  allowDeleting: any | boolean;

  @Prop({
    default: () => {
      return {
        mode: "cell",
        allowAdding: true,
        allowUpdating: true,
        allowDeleting: true,
        texts: {
          confirmDeleteMessage: "¿Desea eliminar el registro?"
        }
      };
    }
  })
  editing: any;

  loadPanel: any = { enabled: false };
  // scrolling: any = { mode: "virtual" };
  filterRow: any = {
    visible: true,
    applyFilter: "auto"
  };
  remoteOperations: boolean = true;

  @Prop({ type: String, default: "GridOData-Insert" })
  nameEventInsert: any | string;

  @Prop({ type: String, default: "GridOData-Update" })
  nameEventUpdate: any | string;

  @Prop({ type: String, default: "GridOData-Delete" })
  nameEventDelete: any | string;

  @Prop({ type: String, default: "GridOData-SelectionChanged" })
  nameEventSelectionChanged: any | string;

  @Prop({ type: String, default: "GridOData-Refresh" })
  nameEventRefresh: any | string;

  @Prop({
    type: Object,
    default: () => {
      return { pageSize: 50 };
    }
  })
  paging: any;

  onToolbarPreparing(e: any) {
    e.toolbarOptions.items.unshift({
      location: "after",
      widget: "dxButton",
      options: {
        icon: "refresh",
        onClick: () => {
          this.grid.refresh();
        }
      }
    });
  }

  destroyed(){
    eventService.off(this.nameEventInsert);
    eventService.off(this.nameEventUpdate);
    eventService.off(this.nameEventDelete);
    eventService.off(this.nameEventSelectionChanged);
    eventService.off(this.nameEventRefresh);
  }

  mounted() {
    this.grid = (<any>this.$refs[this.idGrid]).instance;
  }

  created() {
    let self = this;
    if (self.headerFilter.visible) {
      // Se añade para cada una de las columnas el buscador en el encabezado y se prepara su datasource
      self.columns.forEach((c: any, i: any) => {
        if (!c.headerFilter || !c.headerFilter.dataSource) {
          c.headerFilter = c.headerFilter || { dataSource: null };
          c.headerFilter.allowSearch = true;
          c.headerFilter.dataSource = {
            load: (loadOptions: any) => {
              if(c.loadAll === true){
                loadOptions.skip = 0;
                loadOptions.take = 100000;
              }
              return self.odataService.loadHeader(
                self.loadDataSource,
                loadOptions,
                c.dataField,
                (res: any) => {
                  let result = [];

                  for (let index = 0; index < res.Items.length; index++) {
                    let element = res.Items[index][c.dataField];
                    if (c.dataType == "datetime") {
                      result.push({
                        text: moment(element, "DD/MM/YYYY HH:mm:ss Z").format(
                          "DD/MM/YYYY HH:mm:ss"
                        ),
                        value: moment(element, "DD/MM/YYYY HH:mm:ss Z").toDate()
                      });
                    } else if (c.dataType == "date") {
                      result.push({
                        text: moment(element, "DD/MM/YYYY HH:mm:ss Z").format(
                          "DD/MM/YYYY"
                        ),
                        value: moment(element, "DD/MM/YYYY").toDate()
                      });
                    } else if (c.dataType == "boolean") {
                      result.push({
                        text: element ? "Sí" : "No",
                        value: element
                      });
                    } else {
                      result.push({
                        text: element,
                        value: element
                      });
                    }
                  }
                  return result;
                }
              );
            }
          };
        }
      });
    }

    // Creamos un CustomStore y sobreescribimos los métodos del CRUD
    self.datasource = new CustomStore({
      key: self.keyExpr,

      // Sobreescribimos el load para obtener las opciones de carga y
      // procesarlas para obtener una queryString de OData.
      // A continuación, se llama a la función que carga los datos
      // pasando como parámetro el queryString.
      // Finalmente, se procesa la respuesta para devolver un objecto que la grid de DevExtreme espere
      load: (loadOptions: any) => {
        return self.odataService.load(
          self.loadDataSource,
          loadOptions,
          (res: any) => {
            return {
              data: res.Items,
              totalCount: res.TotalCount
            };
          }
        );
      },

      // Sobreescribimos el insert y lanzamos un event con el nuevo elemento
      insert: (values: any) => {
        eventService.emit(self.nameEventInsert, values);
        return values;
      },

      // Sobreescribimos el update, buscamos el elemento modificado y lanzamos un event con el elemento
      update: (key: any, values: any) => {
        let rows = self.grid.getVisibleRows();
        let rowIndex = self.grid.getRowIndexByKey(key);
        let row = rows[rowIndex].data;

        eventService.emit(self.nameEventUpdate, row);
        return row;
      },

      // Sobreescribimos el remove, buscamos el elemento eliminado y lanzamos un event con el elemento
      remove: (key: any) => {
        let rows = self.grid.getVisibleRows();
        let rowIndex = self.grid.getRowIndexByKey(key);
        let row = rows[rowIndex].data;

        eventService.emit(self.nameEventDelete, row);
        return row;
      }
    });

    eventService.on(self.nameEventRefresh, () =>{
      self.grid.refresh();
    })
  }

  onSelectionChanged(event: any) {
    eventService.emit(this.nameEventSelectionChanged, event);
  }

  onDelete(row: any){
    eventService.emit(this.nameEventDelete, row.data);
  }
}
